<template>
  <div class="bcgContain d-flex justify-content-center">
    <div class="bcgContainSur my-auto">
      <div class="container bcgCard py-5">
        <div class="row py-5 d-flex justify-content-end">
          <div class="col-4 col-md-3 col-lg-3 ml-lg-n14">
            <router-link to="/" class="link">
              {{ $t("back") }} &rsaquo;
            </router-link>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div
            class="col-12 col-lg-4 order-lg-1 order-md-1 order-sm-12 order-12"
          >
            <div v-if="show.signIn">
              <SignIn />
              <div class="row">
                <div class="col-12">
                  <span class="small gray-text">{{
                    $t("forget-password")
                  }}</span
                  ><span
                    @click="(show.signIn = false), (show.OTP = true)"
                    class="small mr-2 blue-text pointer"
                    >{{ $t("otp") }}</span
                  >
                </div>
                <div class="col-12 mt-n5">
                  <span class="small gray-text">{{ $t("not-register") }}</span
                  ><span
                    @click="(show.signIn = false), (show.OTP = true)"
                    class="small mr-2 blue-text pointer"
                    >{{ $t("sign-up") }}</span
                  >
                </div>
              </div>
            </div>
            <!-- <div v-if="show.signUp">
              <SignUp />
              <div class="col-12">
                <span class="small gray-text">{{ $t("signIn-before") }}</span
                ><span
                  @click="
                    (show.signIn = true),
                      (show.signUp = false),
                      (show.OTP = false)
                  "
                  class="small mr-2 blue-text pointer"
                  >{{ $t("signIn") }}</span
                >
              </div>
            </div> -->
            <div v-if="show.OTP">
              <OTP />
            </div>
          </div>
          <div
            class="col-12 col-lg-7 order-lg-12 order-md-1 order-sm-1 order-1 d-flex justify-content-center"
          >
            <img src="../assets/image/Sign.png" width="85%" alt="Sign" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SignIn from "../components/Sign/SignIn.vue";
import OTP from "../components/Sign/OTP.vue";
// import SignUp from "../components/Sign/SignUp.vue";
export default {
  data() {
    return {
      show: {
        signIn: true,
        // signUp: false,
        otp: false,
      },
    };
  },
  components: {
    SignIn,
    OTP,
    // SignUp,
  },
};
</script>
<style scoped>
.bcgContain {
  background-image: url(../assets/image/gray.png);
  min-height: 100vh;
  width: 100%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.bcgContainSure {
  background-color: #f9f9f9;
  height: 100%;
  width: 100%;
}
.bcgCard {
  height: 85%;
  width: 80%;
  z-index: 1;
  background-color: #fff;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}
</style>
